import { FormEvent, useEffect, useState } from "react";
import { EncryptionService } from "../../services/EncryptionService";
import { getESPECUrl } from "../../config";
import useAPI from "../../Hooks/useAPI";
import { useUser } from "../../Context/UserContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import sent from "../../Pages/Sent/Sent.module.css";
import Header from "../Header2/Header2";
import Footer from "../Footer/FooterSmall";

export interface UserData {
  id: string;
}

const RedirectESPEC: React.FC = () => {
  const { user, setUser, hasPermission } = useUser();
  const [isReady, setIsReady] = useState(false);
  const { addUserTracking } = useAPI();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // if (!user) {
  //     return <div>User does not have permission</div>;
  // }

  useEffect(() => {
    // Redirect if not admin
    console.log(window.location.href);
    if (!user) {
      navigate("/");
      return;
    }
  }, [user?.roles, navigate]);

  const [encryptionService] = useState(() => new EncryptionService());

  const encryptField = (value: string): string => {
    return encryptionService.encryptField(value);
  };

  useEffect(() => {
    const loadKey = async () => {
      try {
        await encryptionService.loadPublicKey();
        setIsReady(true);
      } catch (err) {
        console.error("Failed to load public key:", err);
      }
    };
    loadKey();
  }, [encryptionService]);

  useEffect(() => {
    if (!isReady || !user) return;

    const ESPECUrl = getESPECUrl();

    if (!encryptionService.getPublicKey()) {
      alert("Public key not loaded");
      return;
    }

    const encryptedParams = (
      Object.keys(updatedUserData) as (keyof UserData)[]
    ).map(
      (key) =>
        `${fieldMap[key]}=${encodeURIComponent(
          encryptField(updatedUserData[key]),
        )}`,
    );

    const finalUrl = `${ESPECUrl}?${encryptedParams.join("&")}`;

    console.log(finalUrl);
    window.location.href = finalUrl;
  }, [isReady, user]); // runs once key + user are ready

  if (!user) return null;

  const updatedUserData = {
    id: String(user.id),
  };

  const fieldMap: Record<keyof UserData, string> = {
    id: "g",
  };

  return (
    <div className="generalPage">
      <div className="landingPage">
        <Header />
        <div className={sent.sentBody}>
          <h2>You are being redirected</h2>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RedirectESPEC;
